import { DatePicker, type DatepickerProps } from 'baseui/datepicker'
import { mergeOverrides } from 'baseui'
import { SDDatePickerOverrides } from './styled-components'

const SDDatePicker = ({ overrides, ...rest }: DatepickerProps) => {
  const newOverrides = mergeOverrides(SDDatePickerOverrides(), overrides)

  return <DatePicker {...rest} overrides={newOverrides} />
}

export default SDDatePicker
